import appConfig from "../config/app-config";

const { address: API_URL, key: API_KEY } = appConfig.apis.convertXmlApiEnv;

export interface CloseOperationRequest {
    contract_code?: string;
    disbursement_value?: number;
    indexer?: string;
    rate?: number;
    operation_guarantee?: string;
    operation_type?: string;
    obligation_type?: string;
    trader?: string;
    validation_xml?: boolean;
    validation_receipt_stub?: boolean;
    validation_contact?: boolean;
    validation_sefaz?: boolean;
    validation_invoice_pdf?: boolean;
    validation_accepted_bill?: boolean;
    validation_purchase_contract?: boolean;
    analysis_criteria?: string;
    analysis_receivables_count?: number;
}

export interface CloseOperationResponse {
    success: boolean;
    message: string;
    operation_id?: string;
    operation_code?: string;
    invalid_receivables?: { document_id: string; document_title: string; receivable_number: string }[];
}

export const closeOperation = async (operationId: string, data: CloseOperationRequest): Promise<CloseOperationResponse> => {
    const response = await fetch(`${API_URL}/operations/${operationId}/close`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-api-key': API_KEY
        },
        body: JSON.stringify(data)
    });

    const result = await response.json();
    return result;
};
